import { User } from 'app/shared/models/user';

function RoleEnumUserClass() {}

RoleEnumUserClass.prototype.ROLE_ENUM = Object.freeze({
  Admin: 'Admin',
  TelemetryUser: 'TelemetryUser',
  Standard: 'Standard',
  FreeTier: 'FreeTier',
});

RoleEnumUserClass.prototype.getUsers = function getUsers() {
  return this.ROLE_ENUM;
};

RoleEnumUserClass.prototype.isAdministrador = function isAdministrador(
  user: User | null = null,
) {
  const role = user?.role ?? (user?.metadata as any)?.role;
  return role === this.ROLE_ENUM.Admin;
};

RoleEnumUserClass.prototype.isRoleFreetier = function isRoleFreetier(
  user: User | null = null,
) {
  const role = user?.role ?? (user?.metadata as any)?.role;
  return user != null && role === this.ROLE_ENUM.FreeTier;
};

RoleEnumUserClass.prototype.isAuthenticated = function isAuthenticated(
  user: User | null = null,
) {
  return user !== undefined && user !== null;
};

const _roleEnumUserClass = new RoleEnumUserClass();

export { _roleEnumUserClass };
